import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import { DeleteOutline } from "@mui/icons-material";
import Multiselect from "multiselect-react-dropdown";
import { showMessage } from "../../Utils/comman";
import Swal from "sweetalert2";

function View(props) {
  const [formData, setFormData] = useState({
    date: moment().format("YYYY-MM-DD"),
    teamMemberName: "",
    teamMemberId: "",
    teamMemberCode: "",
    location: "",
    channelPartner: "",
    purpose: "",
    siteDetails: "",
    siteAddress: "",
    expectedSales: "",
    products: [
      {
        id: 0,
        productId: "",
        productName: "",
        productSize: "",
        productQty: "",
        productQtyKg: "",
      },
    ],
    totals: {
      qty: "",
      kgQty: "",
    },
    product_delete: [],
  });
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEdit, setisEdit] = useState(false);

  const [products, setProducts] = useState([]);
  const [ttmStatus, setTtmStatus] = useState("");
  const [note, setNote] = useState("");
  const [Errors, setErrors] = useState({});
  const [noteStatus, setNoteStatus] = useState("");
  const [loadingAccept, setLoadingAccept] = useState(false); // State to manage loading for Accept button
  const [loadingReject, setLoadingReject] = useState(false);
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleStoreInputChange = (e) => {
    const { name, value } = e.target;

    // Remove leading spaces only (leave trailing spaces intact)
    const cleanedValue = value.replace(/^\s+/, "");

    if (name === "note") {
      setNote(cleanedValue);
      setErrors((prevErrors) => ({
        ...prevErrors,
        note: cleanedValue ? "" : prevErrors.note,
      }));
    }
  };

  const handleNoteAccept = () => {
    const validationErrors = finalCtoValidate();
    setErrors(validationErrors);
    if (note !== "") setNoteStatus("1");
  };

  const handleNoteReject = (e) => {
    const validationErrors = finalCtoValidate();

    setErrors(validationErrors);
    if (note !== "") setNoteStatus("2");
  };
  const finalCtoValidate = () => {
    const newErrors = {};
    if (!note) {
      newErrors.note = "Note is required";
    }
    return newErrors;
  };

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (noteStatus === "1" || noteStatus === "2") {
      if (noteStatus === "1") {
        sendNoteStatus("accept");
      } else if (noteStatus === "2") {
        sendNoteStatus("reject");
      }
    }
  }, [noteStatus]);

  const sendNoteStatus = (type) => {
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else {
      setLoadingReject(true); // Start loader for Reject button
    }

    var bodyFormData = new FormData();
    if (noteStatus !== "") {
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("status", noteStatus);
      bodyFormData.append("remarks", note);

      utils
        .callAPI("post", `/sales/approve_requisition_rm`, bodyFormData)
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }

          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                noteStatus === "1"
                  ? "Sample Request has been accepted."
                  : "Sample Request has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            // Handle undefined response
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader on error for Accept button
          } else {
            setLoadingReject(false); // Stop loader on error for Reject button
          }

          // Handle error
        });
    }
  };

  const handleDownload = () => {
    utils
      .callAPI("get", `/sales/download_form/${props.rowData?.id}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          // window.open(res, "_blank");
          const a = document.createElement("a");
          a.href = res;
          a.target = "_blank";
          a.rel = "noopener noreferrer";
          a.click();
        } else {
        }
      })
      .catch((err) => {});
  };

  return (
    <div className="section-body ">
      <RB.Card>
        <RB.Card.Header>
          <h4>{"Free Sample Requisition Form"}</h4>
          <div className="card-header-action mt-0 ms-0 ms-md-auto">
            <RB.Button className="btn btn-light me-2" onClick={handleDownload}>
              Download
            </RB.Button>
            <RB.Button
              className="btn btn-primary me-2 "
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form>
            <RB.Row className={"row-cols-md-2 row-cols-1 mb-3"}>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {moment(props.rowData?.date).format("DD-MM-yyyy")}
                </p>
              </RB.Col>
              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Team Member Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData?.team_member_name}
                </p>
              </RB.Col>

              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Location
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData?.location}
                </p>
              </RB.Col>

              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Channel Partner Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData?.channel_partner?.companyName}
                </p>
              </RB.Col>

              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Purpose of Free Sample
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData?.purpose_of_free_sample}
                </p>
              </RB.Col>

              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Expected Sales
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData?.expected_sales}
                </p>
              </RB.Col>

              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Site Details (Area, Scope of Work etc.)
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData?.site_details}
                </p>
              </RB.Col>

              <RB.Col md={6}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Site Address
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData?.site_address}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Card className={"border mb-0 rounded-0"}>
              <RB.CardHeader>
                <h6 className={"mb-0"}>Products</h6>
              </RB.CardHeader>
              <RB.Table bordered responsive striped className={"mb-0"}>
                <thead>
                  <tr>
                    <th className={"text-center"} style={{ width: "5%" }}>
                      Sr.No.
                    </th>
                    <th>Product Name</th>
                    <th style={{ width: "15%" }} className={"text-end"}>
                      Pact Size (KG.)
                    </th>
                    <th style={{ width: "15%" }} className={"text-center"}>
                      Req. Qty No.
                    </th>
                    <th style={{ width: "20%" }} className={"text-end"}>
                      Qty KG.
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {props?.rowData?.products &&
                    props?.rowData?.products.map((product, i) => (
                      <tr key={i}>
                        {console.log(
                          "Here is the product",
                          product.product_name
                        )}
                        <td className={"text-center align-items-center"}>
                          {i + 1}
                        </td>
                        <td>{product.product_name}</td>
                        <td className={"text-end"}>{product.pack_size}</td>
                        <td className={"text-end"}>{product.qty}</td>
                        <td className={"text-end"}>{product.total_kg_qty}</td>
                      </tr>
                    ))}
                </tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    <th>Total</th>
                    <th></th>
                    <th className={"text-end"}>{props?.rowData?.total_qty}</th>
                    <th className={"text-end"}>
                      {props?.rowData?.total_qty_kg}
                    </th>
                  </tr>
                </tfoot>
              </RB.Table>
            </RB.Card>

            {userProfile.employeeId === props.rowData.reporting_manager &&
              props.rowData.reporting_manager_status === null && (
                <>
                  <h6 className="mt-4">Note</h6>
                  <hr className="hr-lg mt-1" />
                  <RB.Row>
                    <RB.Col md={12} className="no-validation-icon">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          controlId="note"
                          className="floating-label-fancy"
                          label="Note"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Enter your note here"
                            name="note"
                            value={note}
                            onChange={handleStoreInputChange}
                            maxLength={500}
                            isInvalid={!!Errors.note}
                            // required={status !== "1"}
                          />
                          <RB.Form.Control.Feedback type="invalid">
                            {Errors.note}
                          </RB.Form.Control.Feedback>
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>
                  </RB.Row>
                  <div>
                    {
                      <>
                        <RB.Button
                          className="me-2"
                          style={{ backgroundColor: "#37c830", color: "white" }}
                          onClick={handleNoteAccept}
                          disabled={loadingAccept} // Disable button while loading
                        >
                          {loadingAccept ? (
                            <RB.Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Accept"
                          )}
                        </RB.Button>
                        <RB.Button
                          style={{ backgroundColor: "red", color: "white" }}
                          onClick={handleNoteReject}
                          disabled={loadingReject} // Disable button while loading
                        >
                          {loadingReject ? (
                            <RB.Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Reject"
                          )}
                        </RB.Button>
                      </>
                    }
                  </div>
                </>
              )}
            {props.rowData.reporting_manager_note !== null && (
              <>
                <h6 className="mt-4">Note</h6>
                <hr className="hr-lg mt-1" />

                <p className="fw-medium text-sm ">
                  {props.rowData.reporting_manager_note}
                </p>
              </>
            )}
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default View;
